import has from './has';
export default has;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.7@@antv/util/esm/has-key.js
// module id = 74
// module chunks = 0